export var API_ENDPOINTS = {
  APIGEE: "apigee"
};